import { Spin } from 'antd';
import React from 'react';
import SgiCtnComponent from './sgiBaseComp/SgiCtnComponent';
import { convertModuleByGuid } from "./SgiCompComm";

export default class SgiSpin extends SgiCtnComponent {
	constructor(props) {
		super(props);

		this.state.loading = false;
		this.state._class = ["sgiSpin", ...this.state._class];
	}

	__fitSonItems() {
		let { moduleDesc, objFct, type } = this.props;
		let { sonItems } = this.state;

		var me = this;
		let cldSet = moduleDesc.cldSet;
		if (cldSet && cldSet.length > 0) cldSet.forEach((item, index) => sonItems.push(convertModuleByGuid(me, item, null, objFct, type)));
	}

	//渲染并返回一个虚拟DOM
	__render = function () {
		return (
			<Spin wrapperClassName={this.state._props.className} {...this.state._props}
				spinning={this.state.loading}>
				{this.state.sonItems}
				{this.props.children}
			</Spin>
		)
	}
}


// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiSpin.js